define( function (require, exports, module) {
    'use strict';

    module.name = 'module-metro-components';

    var contextRoot = '';
    var featuresRoot = 'static/features/[BBHOST]';

    if(window.b$ && window.b$.portal && window.b$.portal.config) {
        if(window.b$.portal.config.serverRoot) {
            contextRoot = window.b$.portal.config.serverRoot;
        }

        /**
         * Widget/Module can't KNOW upper structure only guess
         * window.b$.portal.config.featuresRoot
         * added to add possibility to mock it
         */
        if(window.b$.portal.config.featuresRoot) {
            featuresRoot = window.b$.portal.config.featuresRoot;
        }
    }

    var templatePath = [
        contextRoot,
        featuresRoot,
        module.name,
        'scripts/templates',
        ''
    ].join('/');

    var base = require('base');
    var core = require('core');
    var ui = require('ui');
    var users = require('module-metro-users');

    require('angular-sanitize');

    var deps = [
        core.name,
        ui.name,
        users.name,
        'ngSanitize'
    ];

    //code goes here

    /**
    *  @ngInject
    */
    module.exports = base.createModule(module.name, deps)

        .filter(require('./filters/iban'))
        .filter(require('./filters/replace'))

        .constant('TEMPLATE_PATH', templatePath)
        .constant('metAccordionConfig', {
            closeOthers: true
        })
        .factory(require('./directives/metTooltip/metTooltipFactory'))
        .controller(require('./directives/metAccordion/metAccordionController'))
        .directive(require('./directives/list'))
        .directive(require('./directives/ice'))
        .directive(require('./directives/metSpinner'))
        .directive(require('./directives/metSearch/metSearch'))
        .directive(require('./directives/metLightbox'))
        .directive(require('./directives/metHeader'))
        .directive(require('./directives/metAlert'))
        .directive(require('./directives/listItem'))
        .directive(require('./directives/listItemLoading'))
        .directive(require('./directives/accordionMetro'))
        .directive(require('./directives/includeExcludeBox'))
        .directive(require('./directives/metScaPayment'))
        .directive(require('./directives/metCard'))
        .directive(require('./directives/sliding-checkbox'))
        .directive(require('./directives/metCheckbox/metCheckbox'))
        .directive(require('./directives/metAccordion/metAccordion'))
        .directive(require('./directives/metListLoader/metListLoader'))
        .directive(require('./directives/metMandates/metMandates'))
        .directive(require('./directives/metInput/metInput'))
        .directive(require('./directives/metNotification'))
        .directive(require('./directives/metTooltip/metTooltip'))
        .directive(require('./directives/metHardtoken/metHardtoken'))
        .directive(require('./directives/metTh/metTh'))
        .directive(require('./directives/message'))
        .directive(require('./directives/why-modal'))
        .directive(require('./directives/scamWarning'))
        .directive(require('./directives/metAmountCurrency'));
        
});



// WEBPACK FOOTER //
// ./scripts/main.js